import '../../../../../node_modules/@lit/reactive-element/reactive-element.js';
import { html as $ } from '../../../../../node_modules/lit-html/lit-html.js';
import '../../../../../node_modules/lit-element/lit-element.js';
import { renderFeatureCard } from './renderFeatureCard.js';

const renderLayout = (component) => {
    const { sectionTitle, sectionTitleId, hideSectionTitle, cards } = component;
    const titleClasses = hideSectionTitle
        ? 'feature-section__title sr-only'
        : 'feature-section__title';
    return $ `<h2 id="${sectionTitleId}" class="${titleClasses}">${sectionTitle}</h2><div class="feature-section__cards">${cards.map((card, index) => renderFeatureCard(card, index))}</div>`;
};

export { renderLayout };
